import CONSTANTS from './constants'
import { format } from 'date-fns'
import { saveAs } from 'file-saver'
import CryptoJS from 'crypto-js'
import { clearAuthKeys, getEncryptionKey } from './authKeysStore'

export const setCookie = ({
  cname,
  cvalue,
  expires,
  domain,
  path,
  cookieExpireTimeType,
}) => {
  if (!path) {
    path = '/'
  }
  if (expires) {
    // If it's a date
    if (expires instanceof Date) {
      // If it isn't a valid date
      if (isNaN(expires.getTime())) {
        expires = new Date()
      }
    } else {
      switch (cookieExpireTimeType) {
        case CONSTANTS.YEARS:
          expires = new Date(
            new Date().getTime() + parseInt(expires) * 1000 * 60 * 60 * 24 * 365
          )
          break
        case CONSTANTS.DAYS:
          expires = new Date(
            new Date().getTime() + parseInt(expires) * 1000 * 60 * 60 * 24
          )
          break
        case CONSTANTS.HOURS:
          expires = new Date(
            new Date().getTime() + parseInt(expires) * 1000 * 60 * 60
          )
          break
        case CONSTANTS.MINUTES:
          expires = new Date(
            new Date().getTime() + parseInt(expires) * 1000 * 60
          )
          break
        case CONSTANTS.SECONDS:
          expires = new Date(new Date().getTime() + parseInt(expires) * 1000)
          break
        default:
          expires = new Date(new Date().getTime() + parseInt(expires))
      }
    }
    expires = `expires=${expires.toUTCString()}`
  }
  document.cookie = `${cname}=${cvalue};${expires};path=${path};${
    domain ? `domain=${domain};` : ''
  }`
}

export const getCookieValue = (cookieName) => {
  const result = document.cookie.replace(
    new RegExp(`(?:(?:^|.*;\\s*)${cookieName}\\s*\\=\\s*([^;]*).*$)|^.*$`),
    `$1`
  )
  return result
}
export const deleteCookie = (name) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
}

export const updateCssVariables = (theme) => {
  document.documentElement.style.setProperty(
    '--limGreen',
    theme.primarySolidColor.hex
  )
  document.documentElement.style.setProperty(
    '--irisBlue',
    theme.secandarySolidColor.hex
  )
  document.documentElement.style.setProperty(
    '--peanutTBrittle',
    theme.primaryButtonGradient1Color.hex
  )
  document.documentElement.style.setProperty(
    '--willpowerOrange',
    theme.unpaidTextColor.hex
  )
  document.documentElement.style.setProperty(
    '--brightGrey',
    theme.usageDetailsBackgroundBarColor.hex
  )
  document.documentElement.style.setProperty(
    '--panache',
    theme.focussedSelectedBackgroundColor.hex
  )
  document.documentElement.style.setProperty(
    '--apple',
    theme.downloadTextColor.hex
  )
  document.documentElement.style.setProperty(
    '--mobilePageBG',
    `url(
      ${theme.header2MobileImage}/png
    )`
  )
  document.documentElement.style.setProperty(
    '--pageBG',
    `url(
      ${theme.header1WebImage}/png
    )`
  )
}

export const clearLoginInfo = () => {
  clearAuthKeys()
  deleteCookie('token')
  deleteCookie('refreshToken')
  deleteCookie('switchToken')
  deleteCookie('corpToken')
  deleteCookie('corp-token')
  deleteCookie('rememberJawwal')
  deleteCookie('paltelToken')
  deleteCookie('paltel-corp-token')
  deleteCookie('rememberPaltel')
  deleteCookie('customer-code-token')
  deleteCookie('customerCodeToken')
  deleteCookie('rememberCustomerCodeToken')
  localStorage.removeItem('persist:root')
  localStorage.removeItem('mainNumber')
  localStorage.removeItem('name')
  localStorage.removeItem('light')
  localStorage.removeItem('dark')
  localStorage.removeItem('themeName')
  localStorage.removeItem('isFcmTokenSend')
  localStorage.removeItem('isPaltelCustomer')
  localStorage.removeItem('serviceData')
  localStorage.removeItem('isServiceDetails')
  localStorage.removeItem('selectedAddOns')
  localStorage.removeItem('_grecaptcha')
  localStorage.removeItem('mins')
  localStorage.removeItem('minsPrice')
  localStorage.removeItem('MobileNo')
  localStorage.removeItem('mapPin')
  localStorage.removeItem('MainNumberIsPaltelCustomer')
  localStorage.removeItem('arriavelTime')
  localStorage.removeItem('sessionData')
  localStorage.removeItem('isCorpAutherized')
  localStorage.removeItem('isPaltelCorpAuthorized')
  localStorage.removeItem('corpAuthorized')
  localStorage.removeItem('jawwalCorpAuthorized')
  localStorage.removeItem('chosenAccount')
  localStorage.removeItem('clickedLogin')
  localStorage.removeItem('customerType')
  localStorage.removeItem('preLoginUrl')
}

export const formatDate = (dateStr) => format(new Date(dateStr), 'yyyy/MM/dd')

export const handleDownloadPDF = (pdfUrl, pdfFileName) => {
  const byteCharacters = atob(pdfUrl)
  const byteNumbers = new Array(byteCharacters.length)

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }

  const byteArray = new Uint8Array(byteNumbers)
  const blob = new Blob([byteArray], { type: 'application/pdf' })

  saveAs(blob, `${pdfFileName}.pdf`)
}

export const msisdnHash = (Msisdn) => {
  const encryptionKey = getEncryptionKey()
  const key = CryptoJS.enc.Utf8.parse(encryptionKey)
  const iv = CryptoJS.enc.Utf8.parse(encryptionKey)

  const ciphertext = CryptoJS.AES.encrypt(Msisdn, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
  })

  return ciphertext.toString()
}

export const decryptAES = (ciphertext) => {
  const keyHex = '65cb343603c7c707e01bd5e5e02e03f2'
  const ivHex = '0000000000000000'

  const key = CryptoJS.enc.Utf8.parse(keyHex)
  const iv = CryptoJS.enc.Hex.parse(ivHex)

  const decrypted = CryptoJS.AES.decrypt(ciphertext, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })

  return decrypted.toString(CryptoJS.enc.Utf8)
}

export const getEncrypted = (selectedRootAccountNumber, phoneNumber) => {
  if (selectedRootAccountNumber && phoneNumber) {
      const account = `${selectedRootAccountNumber}&${phoneNumber}`
      const aesKey = CryptoJS.enc.Utf8.parse('65cb343603c7c707e01bd5e5e02e03f2') 
      const iv = CryptoJS.enc.Utf8.parse('\0'.repeat(16)) 

      const encrypted = CryptoJS.AES.encrypt(account, aesKey, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      })

      return encrypted.toString()
    }
  }


export default getEncrypted
